module.exports = __webpack_public_path__ + "static/media/banking.a0490c14.svg";